export const review = {
  id: "",
  user: "",
  title: "",
  category: "",
  rating: 0,
  text: "",
  comments: [],
  timestamp: 0
}

export const metadata = [
  {value: "title", display: "Title", element: "input", col: 6, required: true},
  {value: "text", display: "Description", element: "textarea", col: 12, required: true}
];
